export default {
    methods: {
        CreatePropertyId: function (fieldName, fieldIndex) {
            var result = fieldName.replace(' ', '_');
            if (fieldIndex !== undefined) {
                result += '_'+ fieldIndex;
            }
            return result;
        }
    }
}